export default {"src":"/_next/static/media/bestSelling.feec674a.svg","height":20,"width":19,"blurWidth":0,"blurHeight":0};